module.exports = __webpack_public_path__ + "img/diagonal-arrow-right-down.73662786.svg";